<div
	(backdropClick)="isLaneDetailsProfileView = !isLaneDetailsProfileView"
	class="app-default-background h-100"
	mat-sidenav-container
>
	<mat-sidenav
		(keydown.escape)="isLaneDetailsProfileView = !isLaneDetailsProfileView"
		[fixedInViewport]="true"
		[mode]="'side'"
		[opened]="isLaneDetailsProfileView"
		[position]="'end'"
		class="app-default-background zIndex-20"
		[ngClass]="{
			fixed_tab_header: !isLaneDetailsProfileView
		}"
		disableClose
	>
		<app-lane-details
			(closeLaneDetails)="isLaneDetailsProfileView = false"
			[carrierLaneData]="carrierLaneData"
			[recentFeedbackList]="recentFeedbackList"
			[openedMatch]="openedQualityObject"
		>
		</app-lane-details>
	</mat-sidenav>

	<div mat-sidenav-content class="h-100">
		<div class="project_details_container h-100">
			<div fxLayout="row" fxLayoutGap="1rem" #pageContentContainer *ngIf="pageContentAfterViewInit">
				<div class="content-container" fxFlex="68">
					<div
						#projectDetailsAndPricingContainer
						class="zIndex-10"
						stickybits
						*ngIf="pageContentAfterViewInit"
					>
						<div class="full-width">
							<div
								*ngIf="projectDetailsStore.projectDTO$ | async; else projectDetailSkeletonLoader"
								fxFlex="100"
							>
								<div>
									<app-project-specifications
										(updateProjectEvent)="
											updateProject(false, 'Project updated successfully.', $event)
										"
										[isUpdatingProject]="isUpdatingProject"
										[project]="projectDetailsStore.projectDTO$ | async"
										class="full-width"
									>
									</app-project-specifications>
								</div>
							</div>
						</div>
						<div
							class="full-width m-t-0-5 m-b-0-5"
							*ngIf="
								showPricingAndRecentTransactions() &&
								(projectDetailsStore.searchTruckForm$ | async) as searchTruckForm
							"
						>
							<app-pricing
								*ngIf="searchTruckForm"
								#pricingComponent
								(lanePricingCompleted)="lanePricingCompleted($event)"
								(pricingFeedbackSubmitted)="resetNoOfSearchesWithoutFeedbackCounter()"
								[inOpportunitiesPage]="true"
								[searchTruckForm]="searchTruckForm"
								[v1PricingLayout]="false"
								[greenScreensEnabled]="greenScreensEnabled"
								class="full-width"
							>
							</app-pricing>
						</div>
					</div>

					<ng-template [ngTemplateOutlet]="recommendedAndProcuredTab"></ng-template>
				</div>

				<div class="content-container" fxFlex="32">
					<div
						*ngIf="{
							projectDTO: projectDetailsStore.projectDTO$ | async,
							searchTruckForm: projectDetailsStore.searchTruckForm$ | async
						} as store"
						class="h-100 full-width"
					>
						<div fxLayout="column" fxFlex>
							<div
								class="hide_scrollbar_in_container overflow_visible quality_tab_container"
								*ngIf="accountSettings.CARRIER_QUALITY"
							>
								<div fxLayout="row">
									<mat-tab-group
										class="custom-tab h-100 full-width disable_tab_header_transition"
										dynamicHeight
										[@.disabled]="true"
										[ngClass]="{
											fixed_tab_header: !isLaneDetailsProfileView
										}"
									>
										<mat-tab>
											<ng-template matTabLabel>
												<span>Quality</span>
											</ng-template>
											<app-quality
												class="full-width"
												*ngIf="
													carrierIdsToFetchNotes.length === 1 &&
													(projectDetailsStore.allProjectCarrierMapsList$
														| async) as allProjectCarrierMapsList
												"
												[carrierId]="carrierIdsToFetchNotes[0]"
												[destinationCity]="projectDTO?.destCity"
												[destinationState]="projectDTO?.destState"
												[originCity]="projectDTO?.originCity"
												[originState]="projectDTO?.originState"
												[mc]="getCarrierMc(allProjectCarrierMapsList)"
												[dot]="getCarrierDot(allProjectCarrierMapsList)"
												[isCarrierInNetwork]="getIsCarrierInNetwork(allProjectCarrierMapsList)"
												[carrierActive]="true"
												[ccBookingRateDisplay]="
													getCarrierQuality(allProjectCarrierMapsList)?.ccBookingRateDisplay
												"
												[ccEngagementRateDisplay]="
													getCarrierQuality(allProjectCarrierMapsList)?.ccEngagementRateDisplay
												"
												[ccFalloffRateDisplay]="
													getCarrierQuality(allProjectCarrierMapsList)?.ccFalloffRateDisplay
												"
												[ccTotalBookedLoads]="
													getCarrierQuality(allProjectCarrierMapsList)?.ccTotalBookedLoads
												"
												[ccScore]="getCarrierQuality(allProjectCarrierMapsList)?.ccScore"
												[vettingOverallDisplay]="vettingOverallDisplay(allProjectCarrierMapsList)"
												[vettingAuthorityDisplay]="
													vettingAuthorityDisplay(allProjectCarrierMapsList)
												"
												[vettingInsuranceDisplay]="
													vettingInsuranceDisplay(allProjectCarrierMapsList)
												"
												[vettingOperationsDisplay]="
													vettingOperationsDisplay(allProjectCarrierMapsList)
												"
												[vettingSafetyDisplay]="vettingSafetyDisplay(allProjectCarrierMapsList)"
												[vettingOtherDisplay]="vettingOtherDisplay(allProjectCarrierMapsList)"
												[infractionDetails]="infractionDetails(allProjectCarrierMapsList)"
												[lastVettingTime]="getLastVettingTime(allProjectCarrierMapsList)"
											>
											</app-quality>
											<mat-card
												*ngIf="carrierIdsToFetchNotes.length > 1"
												class="m-t-1 primary-text font-size-17"
												fxFlex="100"
												fxLayoutAlign="center center"
											>
												Quality score is available for a single selected carrier
											</mat-card>

											<app-quality-stats
												*ngIf="
													!carrierIdsToFetchNotes.length &&
													(tabGroup?.selectedIndex == 0
														? true
														: !(projectDetailsStore.loadingProjectCarrierMaps$ | async))
												"
												class="full-width"
												[capacitySearchResult]="onRecommendedTab"
												[engagedProjectCarrierMap]="onEngagedTab"
												[procuredProjectCarrierMap]="onProcuredTab"
												[capacitySearchList]="
													recommendedCarriersComponent?.pannelWrapperComponent
														?.capacitySearchResults
												"
												[projectCarrierMapsList]="
													onEngagedTab
														? (projectDetailsStore.engagedCarriersList$ | async)
														: procuredTabCarriersList
												"
											>
											</app-quality-stats>
										</mat-tab>
									</mat-tab-group>
								</div>
							</div>

							<div
								fxFlex
								class="zIndex-10 app-default-background hide_scrollbar_in_container overflow_scroll"
								[stickyOffset]="0"
								stickybits
								style="height: inherit"
							>
								<div fxLayout="row">
									<mat-tab-group
										class="custom-tab h-100 full-width disable_tab_header_transition"
										dynamicHeight
										[@.disabled]="true"
										[ngClass]="{
											fixed_tab_header: !isLaneDetailsProfileView
										}"
									>
										<mat-tab>
											<ng-template matTabLabel>
												<span>Notes</span>
												<span
													[matBadge]="totalNumberOfNotes"
													class="ml-6 custom-badge"
													matBadgeOverlap="false"
												></span>
											</ng-template>
											<div
												*ngIf="
													store.projectDTO?.id && store.searchTruckForm;
													else notesSkeletonLoader
												"
											>
												<div
													*ngIf="carrierIdsToFetchNotes.length > 1"
													class="font-size-13 label-text-light pt-2"
													fxLayout="row"
													fxLayoutAlign="start center"
												>
													Notes can be listed for a single selected carrier or the Projects
												</div>
												<div style="overflow-y: scroll; max-height: 100vh">
													<div *ngFor="let carrier of carrierIdsToFetchNotes | slice: 0 : 1">
														<app-note-list
															*ngIf="carrierIdsToFetchNotes.length === 1"
															(noteCountUpdated)="totalNumberOfNotes = $event"
															[noteType]="getNoteType()"
															[id]="carrier"
															[name]="null"
															[supportId]="store.projectDTO.id"
															[showFeedback]="false"
														></app-note-list>
													</div>
													<app-note-list
														*ngIf="carrierIdsToFetchNotes.length !== 1"
														(noteCountUpdated)="totalNumberOfNotes = $event"
														[noteType]="getNoteType()"
														[id]="store.projectDTO.id"
														[name]="store.projectDTO.name"
													></app-note-list>
												</div>
											</div>
										</mat-tab>
										<mat-tab *ngIf="productsService.TASKS">
											<ng-template matTabLabel>
												<span>Tasks</span>
												<span
													[matBadge]="totalNumberOfTasks"
													class="ml-6 custom-badge"
													matBadgeOverlap="false"
												></span>
											</ng-template>
											<div *ngIf="!utilService.isNullOrUndefined(projectId)" fxLayout="row">
												<app-tasks-infinite-scroll
													(totalNumberOfTasks)="totalNumberOfTasks = $event"
													[projectDTO]="projectDetailsStore.projectDTO$ | async"
													[projectId]="projectId"
													fxFlex="100"
												></app-tasks-infinite-scroll>
											</div>
										</mat-tab>
									</mat-tab-group>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<ng-template #recommendedAndProcuredTab>
			<div
				class="hide_scrollbar_in_container overflow_y full-width"
				[ngStyle]="{
					height:
						pageContentContainer?.nativeElement?.offsetHeight &&
						projectDetailsAndPricingContainer?.nativeElement?.offsetHeight
							? 'calc(' +
								(pageContentContainer.nativeElement.offsetHeight -
									(projectDetailsAndPricingContainer.nativeElement.offsetHeight + 8)) +
								'px)'
							: 'height: calc(100vh - (49px + 239px + 48px + 1.5rem + 119px + 0.5rem))'
				}"
			>
				<div class="full-width h-100" fxLayout="row" fxLayoutAlign="top left">
					<div fxFlex>
						<mat-tab-group
							#tabGroup
							(selectedTabChange)="resetSelectedCarriers(); onTabChange()"
							class="custom-tab tab-button disable_tab_header_transition h-100"
							dynamicHeight
							[@.disabled]="true"
							[ngClass]="{
								fixed_tab_header: !isLaneDetailsProfileView
							}"
						>
							<mat-tab [disabled]="recommendedCarriersStore.loadingLanesList$ | async">
								<ng-template matTabLabel>
									<div
										class="full-width"
										fxLayoutAlign="center center"
										dragHintClass="no-border"
										droppable
										(drop)="onRecommendedTabDrop($event)"
										[dragOverClass]="'dropHover'"
									>
										<span> Recommended </span>
										<span
											*ngIf="
												!(recommendedCarriersStore.loadingLanesList$ | async) &&
												!(projectDetailsStore.loadingProject$ | async)
											"
											[matBadge]="
												recommendedCarriersComponent?.pannelWrapperComponent?.capacitySearchResults
													.length
											"
											[ngClass]="{
												'custom-badge-w-auto':
													recommendedCarriersComponent?.pannelWrapperComponent
														?.capacitySearchResults.length >= 100
											}"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										>
										</span>
										<mat-spinner
											*ngIf="
												(recommendedCarriersStore.loadingLanesList$ | async) ||
												(projectDetailsStore.loadingProject$ | async)
											"
											[diameter]="11"
											class="m-b-1"
										></mat-spinner>
									</div>
								</ng-template>

								<div *ngIf="recommendedCarriersStore.loadingLanesList$ | async" class="m-t-0-5">
									<app-skeleton-loader
										cssClasses="contaier_height_auto"
										[SHOW_PANEL]="true"
										[DEFAULT_ROWS_SIZE]="4"
									>
									</app-skeleton-loader>
								</div>

								<div
									*ngIf="
										(projectDetailsStore.projectDTO$ | async) &&
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async)
									"
									class="m-b-1"
									style="height: inherit"
								>
									<div
										class="full-width overflow_scroll app-default-background zIndex-20 h-100"
										[ngClass]="{
											'zIndex-10': !isLaneDetailsProfileView
										}"
									>
										<div
											class="py-2 font-size-12 label-text-light zIndex-20 app-default-background"
											[ngClass]="{
												'zIndex-10': !isLaneDetailsProfileView
											}"
											fxLayout="row"
											stickybits
											[stickyOffset]="0.1"
										>
											<div fxFlex fxLayoutAlign="start center">Shift + Click to multi-select</div>
											<div fxFlex fxLayoutAlign="end center">
												{{
													recommendedCarriersComponent?.pannelWrapperComponent?.totalSearchLength
												}}
												Matching
												{{
													recommendedCarriersComponent?.pannelWrapperComponent?.totalSearchLength >
													1
														? 'Carriers'
														: 'Carrier'
												}}
											</div>
										</div>

										<div class="recommended_carriers_contaiener">
											<app-recommended-carriers
												style="flex: 1"
												#recommendedCarriersComponent
												(lanesCount)="NUMBER_OF_LANES = $event; populateSearchTruckForm()"
												(openLaneDetails)="openFullProfile($event, null)"
												(updateSelectedcarrierIds)="
													selectedCarrierIds = $event; populateCarrierIdsToFetchNotes()
												"
												[minLoadsPerWeek]="carrierFiltersModel.minLoadsPerWeek"
												[projectDTO]="projectDetailsStore.projectDTO$ | async"
											></app-recommended-carriers>
										</div>
									</div>
								</div>
							</mat-tab>

							<mat-tab *ngIf="environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS">
								<ng-template matTabLabel>
									<div
										class="full-width"
										fxLayoutAlign="center center"
										dragHintClass="no-border"
										droppable
										(drop)="onEngagedTabDrop($event)"
										[dragOverClass]="'dropHover'"
									>
										<span> Engaged </span>
										<span
											[matBadge]="
												(projectDetailsStore.engagedCarriersCount$ | async) > 0
													? (projectDetailsStore.engagedCarriersCount$ | async)
													: ''
											"
											[ngClass]="{
												'custom-badge-w-auto':
													(projectDetailsStore.engagedCarriersCount$ | async) >= 100
											}"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										>
										</span>
									</div>
								</ng-template>

								<br *ngIf="projectDetailsStore.loadingProjectCarrierMaps$ | async" />

								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async) &&
										(projectDetailsStore.engagedCarriersList$ | async).length === 0
									"
								>
									<mat-card class="m-t-1 m-b-1 padding-0-5" fxFlex fxLayoutAlign="center center">
										No carriers are engaged. You can start by clicking on the Recommended tab and
										looking at the list of matches we have identified.
									</mat-card>
								</div>

								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async);
										else carrierMapSkeletonLoader
									"
								>
									<div
										class="full-width overflow_scroll app-default-background zIndex-20"
										[ngClass]="{
											'zIndex-10': !isLaneDetailsProfileView
										}"
									>
										<div
											class="py-2 font-size-12 label-text-light zIndex-20 app-default-background"
											[ngClass]="{
												'zIndex-10': !isLaneDetailsProfileView
											}"
											fxLayout="row"
											fxLayoutAlign="end center"
											stickybits
											[stickyOffset]="0.1"
										>
											Shift + Click to multi-select
										</div>

										<app-procured-carriers
											#engagedCarriersComponent
											(fireSegmentEvent)="
												fireSegmentEvent($event?.projectId, $event?.carrierId, $event?.cIndex)
											"
											(openFullProfileEvent)="
												openFullProfile($event?.projectCarrierMap, $event?.event)
											"
											(panelClicked)="panelClicked($event?.projectCarrierMap, $event?.event)"
											[projectDTO]="projectDetailsStore.projectDTO$ | async"
											[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
											[isCarrierRatesEnabled]="isCarrierRatesEnabled"
											[isLoadingAccountCarrierLanes]="
												projectDetailsStore.loadingAccountCarrierLanes$ | async
											"
											[projectCarrierMapList]="projectDetailsStore.engagedCarriersList$ | async"
											[searchTruckForm]="searchTruckForm"
											[selectedProjectCarrierMapIDs]="selectedProjectCarrierMapIDs"
											[usersList]="projectDetailsStore.usersList$ | async"
											[userCarrierMapList]="recommendedCarriersStore.userCarrierMapList$ | async"
											[userCarrierMap]="recommendedCarriersStore.userCarrierMap$ | async"
											[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
											[CARRIER_QUALITY_ENABLED]="CARRIER_QUALITY_ENABLED"
										></app-procured-carriers>
									</div>
								</div>
							</mat-tab>

							<mat-tab>
								<ng-template matTabLabel>
									<div
										class="full-width"
										fxLayoutAlign="center center"
										dragHintClass="no-border"
										droppable
										(drop)="onProcuredTabDrop($event)"
										[dragOverClass]="'dropHover'"
									>
										<span> Procured </span>
										<span
											[matBadge]="
												(projectDetailsStore.procuredCarriersCount$ | async) > 0
													? (projectDetailsStore.procuredCarriersCount$ | async)
													: ''
											"
											[ngClass]="{
												'custom-badge-w-auto':
													(projectDetailsStore.procuredCarriersCount$ | async) >= 100
											}"
											class="ml-6 custom-badge"
											matBadgeOverlap="false"
										>
										</span>
									</div>
								</ng-template>

								<br *ngIf="projectDetailsStore.loadingProjectCarrierMaps$ | async" />
								<div
									*ngIf="
										(projectDetailsStore.procuredCarriersCount$ | async) === 0 &&
										(projectDetailsStore.procuredCarriersWithoutGroupCount$ | async) === 0 &&
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async)
									"
								>
									<mat-card class="m-t-1 m-b-1 padding-0-5" fxFlex fxLayoutAlign="center center">
										No carriers have been added to this project. You can start by clicking on the
										Recommended tab and looking at the list of matches we have identified.
									</mat-card>
								</div>

								<div
									*ngIf="
										!(projectDetailsStore.loadingProjectCarrierMaps$ | async);
										else carrierMapSkeletonLoader
									"
								>
									<div
										class="full-width overflow_scroll app-default-background zIndex-20"
										[ngClass]="{
											'zIndex-10': !isLaneDetailsProfileView
										}"
									>
										<div
											class="py-2 font-size-12 label-text-light zIndex-20 app-default-background"
											[ngClass]="{
												'zIndex-10': !isLaneDetailsProfileView
											}"
											fxLayout="row"
											fxLayoutAlign="end center"
											stickybits
											[stickyOffset]="0"
										>
											Shift + Click to multi-select
										</div>

										<div *ngIf="projectId">
											<app-project-groups
												#projectGroups
												(procuredCarriersSelectionUpdated)="procuredCarriersSelectionUpdated()"
												(openFullProfileEvent)="
													openFullProfile($event?.projectCarrierMap, $event?.event)
												"
											>
											</app-project-groups>
										</div>

										<app-procured-carriers
											#procuredCarriersComponent
											(fireSegmentEvent)="
												fireSegmentEvent($event?.projectId, $event?.carrierId, $event?.cIndex)
											"
											(openFullProfileEvent)="
												openFullProfile($event?.projectCarrierMap, $event?.event)
											"
											(panelClicked)="panelClicked($event?.projectCarrierMap, $event?.event)"
											[accountCarrierLanes]="projectDetailsStore.accountCarrierLanes$ | async"
											[isCarrierRatesEnabled]="isCarrierRatesEnabled"
											[isLoadingAccountCarrierLanes]="
												projectDetailsStore.loadingAccountCarrierLanes$ | async
											"
											[projectCarrierMapList]="projectDetailsStore.procuredCarriersList$ | async"
											[projectDTO]="projectDetailsStore.projectDTO$ | async"
											[searchTruckForm]="searchTruckForm"
											[selectedProjectCarrierMapIDs]="selectedProjectCarrierMapIDs"
											[isCarrierVettingIntegrationEnabled]="isCarrierVettingIntegrationEnabled"
											[CARRIER_QUALITY_ENABLED]="CARRIER_QUALITY_ENABLED"
										></app-procured-carriers>
									</div>
								</div>
							</mat-tab>

							<mat-tab disabled>
								<ng-template class="full-width" matTabLabel>
									<div fxFlex fxLayoutAlign="end center" fxLayoutGap="0.5rem">
										<button
											mat-raised-button
											color="primary"
											[mtxPopoverTriggerFor]="capacitySearchFiltersPopover"
											mtxPopoverTriggerOn="click"
											#popoverTrigger="mtxPopoverTrigger"
										>
											FILTER
											<mat-icon>expand_more</mat-icon>
										</button>

										<button
											*ngIf="tabGroup.selectedIndex === 0"
											mat-raised-button
											color="primary"
											[mtxPopoverTriggerFor]="capacitySearchSortPopover"
											mtxPopoverTriggerOn="click"
											#popoverTrigger="mtxPopoverTrigger"
										>
											SORT
											{{
												carrierFiltersModel.capacitySearchSort === 'match'
													? '(BEST Match)'
													: carrierFiltersModel.capacitySearchSort === 'quality'
														? '(Quality)'
														: '(Frequency)'
											}}
											<mat-icon>expand_more</mat-icon>
										</button>

										<button
											mat-raised-button
											color="primary"
											[matMenuTriggerFor]="recommendedTabActions"
										>
											ACTIONS
											<mat-icon>expand_more</mat-icon>
										</button>
										<mat-menu fxFlex #recommendedTabActions="matMenu">
											<button
												(click)="addCarrierContact()"
												color="primary"
												mat-menu-item
												*ngIf="
													!utilService.isNullOrUndefined(tabGroup) &&
													showProcuredTabOptions(tabGroup.selectedIndex) &&
													(projectDetailsStore.projectGroups$ | async)?.length
														? !moreThanOneProjectCarrierMapSelected(
																(projectDetailsStore.projectGroups$ | async)?.length
															)
														: selectedProjectCarrierMapIDs.length == 1
												"
											>
												Add Contact
											</button>

											<app-request-for-proposal
												(updatedData)="rfpCompleted($event)"
												*ngIf="
													!utilService.isNullOrUndefined(tabGroup) &&
													showProcuredTabOptions(tabGroup.selectedIndex)
												"
												[buttonText]="'Check Capacity'"
												[isOnRecommendedTab]="false"
												[numberOfCarriers]="projectDetailsStore.procuredCarriersCount$ | async"
												[projectDTO]="projectDetailsStore.projectDTO$ | async"
												[useMenuButton]="true"
											></app-request-for-proposal>

											<button
												(click)="openBADialog()"
												color="primary"
												[disabled]="!bookingAssistantService.isBookingAssistantEnabled()"
												mat-menu-item
											>
												Get Options
											</button>

											<ng-container *ngIf="tabGroup.selectedIndex == 0">
												<button
													(click)="engageWithCarriers()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedCarrierIds.length"
													*ngIf="environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS"
												>
													Engage
												</button>
												<button
													(click)="moveRecommendedToProcured()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedCarrierIds.length"
												>
													Procure
												</button>
												<button
													(click)="downloadCapacitySearchResultsCsv()"
													color="primary"
													mat-menu-item
												>
													Export
												</button>
												<button
													(click)="utilService.navigateToCapacitySearch(projectDTO)"
													color="primary"
													mat-menu-item
												>
													Search Capacity
												</button>
											</ng-container>

											<ng-container *ngIf="tabGroup.selectedIndex == 1">
												<button
													(click)="moveEngagedToProcured()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedProjectCarrierMapIDs.length"
													*ngIf="environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS"
												>
													Procure
												</button>
												<button
													(click)="removeEngagedCarriers()"
													color="primary"
													mat-menu-item
													[disabled]="!selectedProjectCarrierMapIDs.length"
													*ngIf="environment.ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS"
												>
													Remove
												</button>
												<button
													(click)="exportEngagedCarriers()"
													[disabled]="!(projectDetailsStore.engagedCarriersCount$ | async)"
													color="primary"
													mat-menu-item
												>
													Export
												</button>
											</ng-container>

											<ng-container
												*ngIf="IS_NOT_NULL_OR_UNDEFINED(tabGroup) && tabGroup.selectedIndex"
											>
												<button
													(click)="addDesiredRate()"
													color="primary"
													mat-menu-item
													[disabled]="
														(projectDetailsStore.projectGroups$ | async)?.length
															? moreThanOneProjectCarrierMapSelected(
																	(projectDetailsStore.projectGroups$ | async)?.length
																)
															: selectedProjectCarrierMapIDs.length !== 1
													"
												>
													Update Rate
												</button>
											</ng-container>

											<ng-container
												*ngIf="
													IS_NOT_NULL_OR_UNDEFINED(tabGroup) &&
													tabGroup.selectedIndex && {
														projectGroupsLength: projectDetailsStore.projectGroups$ | async
													} as store
												"
											>
												<button
													(click)="reportDataAction('lane')"
													color="primary"
													mat-menu-item
													[disabled]="
														!!moreThanOneProjectCarrierMapSelected(store.projectGroupsLength.length)
													"
												>
													Report Incorrect Lane
												</button>
												<button
													(click)="reportDataAction('contact')"
													color="primary"
													mat-menu-item
													[disabled]="
														!!moreThanOneProjectCarrierMapSelected(store.projectGroupsLength.length)
													"
												>
													Report Incorrect Contact
												</button>
											</ng-container>

											<ng-container
												*ngIf="
													accountSettings.PROJECT_GROUPS_ENABLED &&
													showProcuredTabOptions(tabGroup.selectedIndex)
												"
											>
												<button
													(click)="createProjectGroup()"
													color="primary"
													mat-menu-item
													[disabled]="
														!selectedProjectCarrierMapIDs.length &&
														!projectGroupsComponent?.ungroupedSelectedProjectCarrierMapIds.length &&
														!projectGroupsComponent?.createGroupFromUserGroupEnabled
													"
												>
													Create Group
												</button>
												<button
													(click)="editProjectGroup()"
													color="primary"
													mat-menu-item
													[disabled]="
														!(projectDetailsStore.projectGroups$ | async)?.length ||
														projectGroupsComponent?.systemGroupSelected ||
														projectGroupsComponent?.selectedProjectGroupIds.length !== 1
													"
												>
													Edit Group
												</button>
												<button
													(click)="addCarriersToGroup()"
													color="primary"
													mat-menu-item
													[disabled]="
														!(projectDetailsStore.projectGroups$ | async)?.length ||
														(!selectedProjectCarrierMapIDs.length &&
															!projectGroupsComponent?.selectedProjectCarrierMapIds.length)
													"
												>
													Add to Group
												</button>
												<button
													(click)="mergeGroups()"
													color="primary"
													mat-menu-item
													[disabled]="
														!(projectDetailsStore.projectGroups$ | async)?.length ||
														projectGroupsComponent?.systemGroupSelected ||
														projectGroupsComponent?.selectedProjectGroupIds.length < 2
													"
												>
													Merge Groups
												</button>
												<button
													(click)="moveProjectGroups('up')"
													color="primary"
													mat-menu-item
													[disabled]="
														!projectGroupsComponent?.selectedProjectGroupIds.length ||
														projectGroupsComponent.highestPriorityGroupSelected ||
														projectGroupsComponent?.systemGroupSelected
													"
												>
													Move Up
												</button>
												<button
													(click)="moveProjectGroups('down')"
													color="primary"
													mat-menu-item
													[disabled]="
														!projectGroupsComponent?.selectedProjectGroupIds.length ||
														projectGroupsComponent.lowestPriorityGroupSelected ||
														projectGroupsComponent?.systemGroupSelected
													"
												>
													Move Down
												</button>
												<button
													(click)="exportProcuredCarriers()"
													[disabled]="!(projectDetailsStore.procuredCarriersCount$ | async)"
													color="primary"
													mat-menu-item
												>
													Export
												</button>
												<button
													(click)="removeFormGroup()"
													color="primary"
													mat-menu-item
													[disabled]="
														!projectGroupsComponent?.selectedProjectCarrierMapIds.length ||
														projectGroupsComponent?.systemGroupSelected
													"
												>
													Remove From Group
												</button>
												<button
													(click)="removeProcuredCarriers()"
													color="primary"
													mat-menu-item
													[disabled]="
														!selectedProjectCarrierMapIDs.length &&
														!projectGroupsComponent?.selectedProjectCarrierMapIds.length
													"
												>
													Remove From Procured
												</button>
												<button
													(click)="deleteGroups()"
													color="primary"
													mat-menu-item
													[disabled]="
														!projectGroupsComponent?.selectedProjectGroupIds.length ||
														projectGroupsComponent?.systemGroupSelected
													"
												>
													Delete Group
												</button>
											</ng-container>
										</mat-menu>
									</div>
								</ng-template>
							</mat-tab>
						</mat-tab-group>
					</div>
				</div>
			</div>
		</ng-template>
	</div>

	<mtx-popover #capacitySearchFiltersPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border" *ngIf="carrierFiltersModel">
			<mat-card-content class="filter_dropdown font-size-14 padding-0-5">
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': tabGroup?.selectedIndex !== 0 || customerOnly }"
					>
						Origin Deadhead
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setOriginDeadhead(-5)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly
							}"
						>
							remove
						</mat-icon>
						<mat-form-field
							floatLabel="never"
							class="number_formfield_filter_container custom-form-field"
						>
							<input
								(keyup.enter)="
									onDeadheadChange(
										CARGOCHIEF_KEYS.ORIGIN_DEADHEAD_SLIDER,
										carrierFiltersModel.originDeadhead
									)
								"
								[(ngModel)]="carrierFiltersModel.originDeadhead"
								autocomplete="off"
								matInput
								type="number"
								class="input_number_field"
								[disabled]="tabGroup?.selectedIndex !== 0 || customerOnly"
							/>
						</mat-form-field>
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setOriginDeadhead(5)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly
							}"
						>
							add
						</mat-icon>
					</div>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': tabGroup?.selectedIndex !== 0 || customerOnly }"
					>
						Destination Deadhead
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setDestinatioDeadhead(-5)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly
							}"
						>
							remove
						</mat-icon>
						<mat-form-field
							floatLabel="never"
							class="number_formfield_filter_container custom-form-field"
						>
							<input
								(keyup.enter)="
									onDeadheadChange(
										CARGOCHIEF_KEYS.DESTINATION_DEADHEAD_SLIDER,
										carrierFiltersModel.destinationDeadhead
									)
								"
								[(ngModel)]="carrierFiltersModel.destinationDeadhead"
								autocomplete="off"
								matInput
								type="number"
								class="input_number_field"
								[disabled]="tabGroup?.selectedIndex !== 0 || customerOnly"
							/>
						</mat-form-field>
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setDestinatioDeadhead(5)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly
							}"
						>
							add
						</mat-icon>
					</div>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': customerOnly }"
					>
						Min Truck Count
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="setPowerUnits(-1)"
							[ngClass]="{ 'disable-text cursor_not_allowed': customerOnly }"
							>remove</mat-icon
						>
						<mat-form-field
							floatLabel="never"
							class="number_formfield_filter_container custom-form-field"
						>
							<input
								[(ngModel)]="carrierFiltersModel.powerUnits"
								autocomplete="off"
								matInput
								type="number"
								class="input_number_field"
								min="0"
								[disabled]="customerOnly"
							/>
						</mat-form-field>
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="setPowerUnits(1)"
							[ngClass]="{ 'disable-text cursor_not_allowed': customerOnly }"
							>add</mat-icon
						>
					</div>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': tabGroup?.selectedIndex !== 0 || customerOnly }"
					>
						Min Frequency
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setMinLoadsPerWeek(-1)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly
							}"
						>
							remove
						</mat-icon>
						<mat-form-field
							floatLabel="never"
							class="number_formfield_filter_container custom-form-field"
						>
							<input
								[(ngModel)]="carrierFiltersModel.minLoadsPerWeek"
								autocomplete="off"
								matInput
								type="number"
								class="input_number_field"
								[disabled]="tabGroup?.selectedIndex !== 0 || customerOnly"
							/>
						</mat-form-field>
						<mat-icon
							class="primary-text cursor-pointer"
							(click)="tabGroup?.selectedIndex !== 0 ? null : setMinLoadsPerWeek(1)"
							[ngClass]="{
								'disable-text cursor_not_allowed': tabGroup?.selectedIndex !== 0 || customerOnly
							}"
						>
							add
						</mat-icon>
					</div>
				</div>
				<div class="m-t-1" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
						[ngClass]="{ 'disable-text': tabGroup?.selectedIndex === 0 }"
					>
						Has Rate
					</div>
					<div fxFlex fxLayout="row" fxLayoutAlign="end center">
						<mat-checkbox
							[(ngModel)]="carrierFiltersModel.ratesOnly"
							[color]="'primary'"
							[labelPosition]="'after'"
							class="fs-13"
							[disabled]="tabGroup?.selectedIndex === 0"
						>
						</mat-checkbox>
					</div>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<div
						fxFlex
						fxLayout="row"
						fxLayoutAlign="start end"
						class="font-weight-bold primary-text"
					>
						MC/DOT
					</div>
					<div fxFlex>
						<mat-form-field floatLabel="never" class="custom-form-field">
							<mat-label>Search</mat-label>
							<input
								[(ngModel)]="carrierFiltersModel.carriersSearchText"
								autocomplete="off"
								matInput
							/>
							<mat-icon
								[matTooltip]="tooltipMessage"
								class="primary-light-color info-icon cursor-pointer"
								content-type="template"
								matSuffix
							>
								info
							</mat-icon>
						</mat-form-field>
					</div>
				</div>

				<div class="m-t-0-5" fxLayout="row">
					<mat-form-field fxFlex class="custom-form-field" floatLabel="never">
						<mat-label>Carrier HQ</mat-label>
						<mat-select
							[(ngModel)]="carrierFiltersModel.carrierHQ"
							[disabled]="tabGroup?.selectedIndex !== 0"
						>
							<mat-option *ngFor="let option of carrierHQOptions" [value]="option">
								{{ option }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-icon
						(click)="removeHQFilter()"
						*ngIf="carrierFiltersModel.carrierHQ.length > 1"
						class="danger-text cursor-pointer"
						>close
					</mat-icon>
				</div>
				<div class="m-t-0-5" fxLayout="row">
					<mat-form-field fxFlex class="custom-form-field">
						<mat-select [(ngModel)]="carrierFiltersModel.carrierSelected">
							<mat-option *ngFor="let option of carriersFilterOptions" [value]="option">
								{{ option }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</mat-card-content>
			<mat-divider></mat-divider>
			<mat-card-actions>
				<div
					fxLayout="row"
					fxLayoutAlign="end center"
					class="p-1 p-t-0"
					*ngIf="recommendedCarriersStore.filters$ | async as storeFilters"
				>
					<button
						mat-raised-button
						color="primary"
						(click)="applyFilter()"
						[disabled]="isFilterChange(storeFilters)"
					>
						Apply
					</button>
				</div>
			</mat-card-actions>
		</mat-card>
	</mtx-popover>

	<mtx-popover #capacitySearchSortPopover="mtxPopover" [closeOnPanelClick]="false">
		<mat-card class="p-0 primary-border" *ngIf="carrierFiltersModel">
			<mat-card-content class="filter_dropdown font-size-14 padding-0-5">
				<div class="m-t-0-5" fxLayout="row">
					<mat-button-toggle-group
						fxFlex
						[(ngModel)]="carrierFiltersModel.capacitySearchSort"
						(change)="sortRecommendedCarriers()"
					>
						<mat-button-toggle [value]="RANGE_FILTERS.SORT.MATCH" fxFlex>
							Best Match
						</mat-button-toggle>
						<mat-button-toggle fxFlex [value]="RANGE_FILTERS.SORT.FREQUENCY">
							Frequency
						</mat-button-toggle>
						<mat-button-toggle fxFlex [value]="RANGE_FILTERS.SORT.QUALITY">
							Quality
						</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
			</mat-card-content>
		</mat-card>
	</mtx-popover>

	<ng-template #projectDetailSkeletonLoader>
		<app-skeleton-loader
			cssClasses="project_details_skeleton_container"
			[SHOW_PANEL]="true"
			[DEFAULT_ROWS_SIZE]="6"
			[DEFAULT_CARDS_SIZE]="1"
			[DEFAULT_COLUMN_SIZE]="4"
		></app-skeleton-loader>
	</ng-template>

	<ng-template #projectFilterSkeletonLoader>
		<div fxLayout="row" fxLayoutGap="1rem" class="m-t-0-5 full-width">
			<div fxFlex>
				<app-skeleton-loader
					cssClasses="project_details_skeleton_container"
					[SHOW_PANEL]="true"
					[DEFAULT_ROWS_SIZE]="1"
					[DEFAULT_CARDS_SIZE]="1"
					[DEFAULT_COLUMN_SIZE]="5"
				></app-skeleton-loader>
			</div>
		</div>
	</ng-template>

	<ng-template #carrierMapSkeletonLoader>
		<app-skeleton-loader
			cssClasses="contaier_height_auto"
			[SHOW_PANEL]="true"
			[DEFAULT_ROWS_SIZE]="3"
			[DEFAULT_CARDS_SIZE]="3"
			[DEFAULT_COLUMN_SIZE]="3"
		></app-skeleton-loader>
	</ng-template>

	<ng-template #pricingSkeletonLoader>
		<div fxLayout="row" fxLayoutGap="1rem">
			<div fxFlex>
				<app-skeleton-loader
					cssClasses="project_details_skeleton_container"
					[SHOW_PANEL]="true"
					[DEFAULT_ROWS_SIZE]="6"
					[DEFAULT_CARDS_SIZE]="1"
					[DEFAULT_COLUMN_SIZE]="2"
				></app-skeleton-loader>
			</div>
			<div fxFlex>
				<app-skeleton-loader
					cssClasses="project_details_skeleton_container"
					[SHOW_PANEL]="true"
					[DEFAULT_ROWS_SIZE]="6"
					[DEFAULT_CARDS_SIZE]="1"
					[DEFAULT_COLUMN_SIZE]="2"
				></app-skeleton-loader>
			</div>
		</div>
	</ng-template>

	<ng-template #notesSkeletonLoader>
		<app-skeleton-loader
			cssClasses="contaier_height_auto"
			[SHOW_PANEL]="true"
			[DEFAULT_ROWS_SIZE]="4"
		>
		</app-skeleton-loader>
	</ng-template>
</div>
